import { Fragment } from "react"
import BottomNavigation from "../features/home/components/BottomNavigation"
import { cn } from "@/lib/utils"
import Navbar from "../atoms/navbar/index.jsx"

interface Props {
  children: React.ReactNode
  showBottomNav?: boolean
  scrollDirection?: "up" | "down"
  onNavigate?: (path: string) => void
  onShowModal?: () => void
  pendingList?: number
  className?: string
}

const MobileLayout = ({ children, showBottomNav = true, scrollDirection = "up", onNavigate, onShowModal, pendingList, className = "" }: Props) => {
  return (
    <Fragment>
      <div className={`min-h-screen bg-gray-50 font-sans text-gray-800 ${className}`}>
        {showBottomNav && (
          <Navbar back={false} subtitle="" />
        )}
        <div className={cn('mx-auto sm:max-w-2xl md:max-w-7xl max-w-md min-h-screen bg-white relative shadow-2xl shadow-gray-200/50', showBottomNav ? 'pb-14' : 'pb-0')}>{children}</div>

        {showBottomNav && (
          <div className={`fixed bottom-0 left-0 right-0 z-50 pointer-events-none flex justify-center transition-transform duration-300 ease-in-out ${scrollDirection === "down" ? "md:translate-y-0 translate-y-full" : "translate-y-0"}`}>
            <div className="w-full max-w-full pointer-events-auto">
              <BottomNavigation onNavigate={onNavigate} onShowModal={onShowModal} pendingList={pendingList} />
            </div>
          </div>
        )}
      </div>
    </Fragment>
  )
}

export default MobileLayout
